import useIsMobile from "../hooks/useIsMobile";
import arrowRightWhite from "../imgs/arrowRightWhite.svg";

import bg from "../images/bottomBg.svg";
import bgMobile from "../imgs/bg-phone-bottom.svg";
import "./SixthPage.css";
import VideoPlayer from "../Components/VideoPlayer";
import { openTalk, openDocument, openJoin } from "./FirstPage";

const data = "https://brevis-media-res.s3.us-west-1.amazonaws.com/website/mp4/video.mp4"

function SixthPage() {
  const { isMobile } = useIsMobile();

  return (
    <div className="sixthPage" id="sixthPage">
      <img src={isMobile ? bgMobile : bg} alt="" className="pageBg" />
      {!isMobile && (
        <div className="videoArea">
          <div className="videoIn">
            <div className="videoCover"></div>
            <VideoPlayer src={data} width="100%" height="100%" />
          </div>
        </div>
      )}
      <div className="title">
        Build With <span className="proof">{`{Proof}`}</span>
      </div>
      {!isMobile && (
        <div
          className="link"
          style={{ top: 186, right: 250 }}
          onClick={() => {
            openTalk();
          }}
        >
          [ Talk to our Team ]{" "}
          <img
            alt=""
            className="arrow_right"
            src={arrowRightWhite}
            onClick={() => {}}
          />
        </div>
      )}
      {!isMobile && (
        <div
          className="link"
          style={{ top: 330, right: 195 }}
          onClick={() => {
            openDocument();
          }}
        >
          [ Explore Documentation ]
          <img
            alt=""
            className="arrow_right"
            src={arrowRightWhite}
            onClick={() => {}}
          />
        </div>
      )}
      {!isMobile && (
        <div
          className="link"
          style={{ top: 470, right: 225 }}
          onClick={() => {
            openJoin();
          }}
        >
          [ Join our Community ]
          <img
            alt=""
            className="arrow_right"
            src={arrowRightWhite}
            onClick={() => {}}
          />
        </div>
      )}
    </div>
  );
}

export default SixthPage;
